import type { Router } from 'vue-router';

export default defineNuxtPlugin(nuxt => {
    (nuxt.$router as Router).beforeEach((to, from) => {
        to.from = from.fullPath !== to.fullPath && from.matched.length ? from : null;
    });
});
